import { useMemo, useState } from "react"
import { ShoppingCart } from "@phosphor-icons/react"
import { Button } from "~/components/design-system/components"
import { useNoosSupplyPlanDetailContext } from "~/context/NoosSupplyPlanDetailProvider"
import { draftBuysByDate } from "~/hooks/useSupplyPlan"
import { useVariantsByIds } from "~/hooks/useVariants"
import { AddToBuyDialog } from "./AddToBuyDialog"
import { CreateBuyDialog } from "./CreateBuyDialog"

type Props = {
  selectedVariantIds: string[]
  clearSelectedVariants: () => void
}

export function NoosBuyActions({ selectedVariantIds, clearSelectedVariants }: Props) {
  const { supplyPlan, buys } = useNoosSupplyPlanDetailContext()
  const variants = useVariantsByIds(selectedVariantIds)
  const [addToBuyOpen, setAddToBuyOpen] = useState(false)
  const [createBuyOpen, setCreateBuyOpen] = useState(false)

  const draftBuys = useMemo(() => draftBuysByDate(buys), [buys])

  return (
    <>
      <Button
        variant="neutral"
        size="sm"
        requires="edit"
        disabled={draftBuys.length === 0}
        allowedTitle={draftBuys.length === 0 ? "No draft buys to add to" : undefined}
        onClick={() => setAddToBuyOpen(true)}
      >
        <ShoppingCart />
        Add to buy
      </Button>
      <Button variant="primary" size="sm" requires="edit" onClick={() => setCreateBuyOpen(true)}>
        <ShoppingCart />
        Create buy
      </Button>
      <AddToBuyDialog
        open={addToBuyOpen}
        onOpenChange={setAddToBuyOpen}
        buys={draftBuys}
        variants={variants}
        onCreateNewBuy={() => setCreateBuyOpen(true)}
      />
      <CreateBuyDialog
        supplyPlanId={supplyPlan.id}
        scopedVariantIds={selectedVariantIds}
        open={createBuyOpen}
        onOpenChange={setCreateBuyOpen}
        onCreated={clearSelectedVariants}
      />
    </>
  )
}
